import type { FC } from 'react'
import { useMemo } from 'react'

import type { IContentPanelProps } from './ContentPanel.model'
import {
  SBodyContent,
  SFooter,
  SHeader,
  SPanelWrapp,
  SScrollableContent,
} from './ContentPanel.styled'

export const ContentPanel: FC<IContentPanelProps> = ({
  header,
  content,
  footer,
}) => {
  const headerContent = useMemo(() => header ?? null, [header])
  const bodyContent = useMemo(() => content ?? null, [content])
  const footerContent = useMemo(() => footer ?? null, [footer])
  return (
    <SPanelWrapp>
      <SHeader>{headerContent}</SHeader>
      <SBodyContent>
        <SScrollableContent>{bodyContent}</SScrollableContent>
      </SBodyContent>
      <SFooter>{footerContent}</SFooter>
    </SPanelWrapp>
  )
}
